import insurerInformationDataGenerator from '@/modules/FileDetail/data/insurerInformation/insurerInformationDataGenerator';
import { insurerInformationQueryFunction } from '@/modules/FileDetail/queries/insurerInformation/insurerInformationQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const insurerInformationQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['insurer_information', id],
    queryFn: () => insurerInformationQueryFunction(id),
    enabled: !!id,
    select(data) {
      return {
        ...data,
        detailCardItems: insurerInformationDataGenerator(data),
      };
    },
  });
